(() => {
  if (window.PUMIIISectionMotion) {
    window.PUMIIISectionMotion.refresh();
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let loadingPromise;

  const loadScript = (src, ready) => {
    if (ready()) return Promise.resolve();
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      return new Promise((resolve) => existing.addEventListener('load', resolve, { once: true }));
    }
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  };

  const ensureGsap = () => {
    if (loadingPromise) return loadingPromise;
    loadingPromise = loadScript(
      'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js',
      () => Boolean(window.gsap)
    ).then(() => loadScript(
      'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js',
      () => Boolean(window.ScrollTrigger)
    ));
    return loadingPromise;
  };

  const initialize = () => {
    if (reducedMotion.matches || !window.gsap || !window.ScrollTrigger) return;
    window.gsap.registerPlugin(window.ScrollTrigger);
    document.querySelectorAll('[data-pumiii-motion]:not([data-motion-ready])').forEach((section) => {
      section.dataset.motionReady = 'true';
      const context = window.gsap.context(() => {
        window.gsap.fromTo(
          section.querySelectorAll('[data-pumiii-reveal]'),
          { y: 28, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.85,
            stagger: 0.08,
            ease: 'power3.out',
            scrollTrigger: { trigger: section, start: 'top 82%', once: true }
          }
        );
        section.querySelectorAll('[data-pumiii-media]').forEach((media) => {
          window.gsap.fromTo(media, { scale: 0.92 }, {
            scale: 1,
            ease: 'none',
            scrollTrigger: { trigger: media, start: 'top 92%', end: 'bottom 34%', scrub: 0.55 }
          });
        });
      }, section);
      section.pumiiiMotionContext = context;
    });
    window.ScrollTrigger.refresh();
  };

  const refresh = () => ensureGsap().then(initialize).catch(() => {});
  window.PUMIIISectionMotion = { refresh };
  refresh();
  document.addEventListener('shopify:section:load', refresh);
})();
